<script>
import { mapGetters, mapState } from 'vuex';

import { formatAmount } from '../lib/formatters';
import { PaymentMethods } from '../';

import CustomerFieldCheckbox from './customer_field_checkbox.vue';
import PaymentMethodAgreementRecurrence from './payment_method_agreement_recurrence.vue';

export default {
  components: {
    CustomerFieldCheckbox,
    PaymentMethodAgreementRecurrence
  },

  data() {
    return {
      checkboxName: {
        [PaymentMethods.AFTERPAY]: 'afterpayAgreement',
        [PaymentMethods.SEPA_DIRECT_DEBIT]: 'sepaAgreement'
      },

      scope: {
        scope: 'pay.js.marketing.payment_methods.agreement'
      }
    };
  },

  computed: {
    ...mapState([
      'amounts',
      'selectedPspCode',
    ]),

    ...mapGetters([
      'payInInstallments'
    ]),

    afterpayLink() {
      if (this.currentLocale() === 'nl') {
        return 'https://www.afterpay.nl/nl/algemeen/betalen-met-afterpay/betalingsvoorwaarden';
      }

      return 'https://www.afterpay.nl/en/about/pay-with-afterpay/payment-conditions';
    },

    formattedTotalSingleDiscountedAmount() {
      return formatAmount(this.amounts.singlePayment.discountedTotal.amountIncVat);
    },

    isAfterpay() {
      return this.selectedPspCode === PaymentMethods.AFTERPAY;
    },

    isDirectDebit() {
      return this.selectedPspCode === PaymentMethods.SEPA_DIRECT_DEBIT;
    },

    inputName() {
      return this.payInInstallments ? 'sepaInstallmentsAgreement' : this.checkboxName[this.selectedPspCode];
    }
  }
};
</script>

<template>
  <customer-field-checkbox :name="inputName">
    <payment-method-agreement-recurrence v-if="payInInstallments" />

    <template v-else>
      <span v-if="isAfterpay">
        {{ t('afterpay', scope) }}

        <a
          :href="afterpayLink"
          target="_blank"
        >
          {{ t('more_information', scope) }}
        </a>
      </span>

      <span v-if="isDirectDebit">
        {{ t('direct_debit', { ...scope, amount: formattedTotalSingleDiscountedAmount }) }}
      </span>
    </template>
  </customer-field-checkbox>
</template>
